import { Illustration } from '@photosi/rn-components/illustration/Illustration';
import { ILLUSTRATION_NAMES } from '@photosi/rn-components/illustration/illustration.helper';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { View } from 'react-native';
import { ProgressBar } from '@photosi/rn-components/progress-bar/ProgressBar';
import { UploadScreenChildProps } from '../UploadScreen.types';

export type UploadingComponentProps = UploadScreenChildProps;

export const UploadingComponent = ({ progress, title, description, style }: UploadingComponentProps) => {
  return (
    <View style={style.uploadingContent}>
      <View style={style.topContent}>
        <View style={{ width: 100, height: 100 }}>
          <Illustration name={ILLUSTRATION_NAMES.Import} />
        </View>
      </View>

      <View style={style.progressBar}>
        <ProgressBar progress={progress} />
      </View>

      <View style={style.textWrapper}>
        <TextLato style={style.title}>{title}</TextLato>
        <TextLato style={style.text}>{description}</TextLato>
      </View>
    </View>
  );
};
